export const LANGUAGE_FOR_OS = {
  EN: "en-US",
  KO: "ko",
  KO_KR: "ko-KR",
};
